import { components } from "@/api-schema";
import { RELOCATION_ORDER_STATUS_FILTER_OPTIONS } from "@/components/filter/predefined/relocation-order-status-filter";

type Vehicle = components["schemas"]["Vehicle"];
type RelocationOrderStatus = components["schemas"]["RelocationOrder"]["status"];

export const BLOCKABLE_RELOCATION_STATUSES = [
  RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Transport_Company_Awaiting_Pickup_Date.id,
  RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Transport_Company_Awaiting_Ready_For_Transport.id,
  RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Completed.id,
  RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Cancelled.id,
] satisfies RelocationOrderStatus[];

export function vehicleIsBlockable(
  vehicle?: Vehicle | null,
  currentRelocationOrderStatus?: RelocationOrderStatus,
): boolean {
  if (!vehicle) {
    return false;
  }

  if (vehicle.vehicleBlock) {
    return false;
  }

  if (currentRelocationOrderStatus) {
    return BLOCKABLE_RELOCATION_STATUSES.includes(currentRelocationOrderStatus);
  }

  if (!vehicle.relocationOrders || vehicle.relocationOrders.length === 0) {
    return true;
  }

  return vehicle.relocationOrders.every((order) => BLOCKABLE_RELOCATION_STATUSES.includes(order.status));
}
